function CourseOtherSlider() {
	var swiper = new Swiper(".js-course-other-slider", {
		slidesPerView: "auto",
		breakpoints: {
			// when window width is >= 992px
			992: {
				allowTouchMove: false
			}
		}
	});
}

export { CourseOtherSlider };